// extracted by mini-css-extract-plugin
export default {"recommend":"Recommend_recommend__NFz+l","info":"Recommend_info__p-Wb-"};